(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const init = (root = document) => {
    const sections = [...root.querySelectorAll('[data-xmas-section]')];
    sections.forEach(section => {
      if (controllers.has(section)) return;
      const abort = new AbortController();
      const on = (target, type, listener, options = {}) => target?.addEventListener(type, listener, {...options, signal: abort.signal});
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const track = section.querySelector('[data-xmas-track]');
      const giftVariants = new WeakMap();
      let revealObserver;
      let stopCarousel = () => {};
      const variantsFor = card => {
        const select = card.querySelector('[data-xmas-variant]');
        if (select) return [...select.options].map(option => ({id:option.value, ...option.dataset, option}));
        if (!giftVariants.has(card)) {
          try { giftVariants.set(card, JSON.parse(card.querySelector('[data-xmas-gift-variants]')?.textContent || '[]')); }
          catch { giftVariants.set(card, []); }
        }
        return giftVariants.get(card);
      };
      const updateCard = (card, chosen) => {
        const select = card.querySelector('[data-xmas-variant]');
        const variant = chosen || variantsFor(card).find(v => String(v.id) === (select?.value || card.dataset.selectedVariant));
        if (!variant) return;
        card.dataset.selectedVariant = String(variant.id);
        const input = card.querySelector('input[name="id"]');
        if (input) input.value = variant.id;
        const price = card.querySelector('[data-xmas-price]');
        price.textContent = variant.money;
        if (variant.compare) {
          const compare = document.createElement('s'); compare.textContent = variant.compare; price.append(' ', compare);
        }
        card.querySelectorAll('[data-xmas-product-link]').forEach(link => {
          const url = new URL(link.href); url.searchParams.set('variant', variant.id); link.href = url.href;
        });
        const image = card.querySelector('.xmas-product__image img');
        if (image && variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
      };
      section.querySelectorAll('[data-xmas-variant]').forEach(select => on(select, 'change', () => updateCard(select.closest('[data-xmas-product]'))));
      const shelf = section.querySelector('[data-xmas-gift-shelf]');
      const applyBudget = budget => {
        if (!shelf) return;
        shelf.querySelectorAll('[data-xmas-budget]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.xmasBudget === budget)));
        let visible = 0;
        shelf.querySelectorAll('[data-xmas-product]').forEach(card => {
          const select = card.querySelector('[data-xmas-variant]');
          const variants = variantsFor(card);
          const matches = variant => budget === 'all' || (budget === 'premium' ? Number(variant.price) >= 10000 : Number(variant.price) < Number(budget) * 100);
          variants.forEach(variant => { if (variant.option) { variant.option.disabled = !matches(variant); variant.option.hidden = !matches(variant); } });
          const first = variants.find(matches);
          card.hidden = !first;
          if (!first) return;
          visible++;
          const current = variants.find(variant => String(variant.id) === (select?.value || card.dataset.selectedVariant));
          const chosen = current && matches(current) ? current : first;
          if (select) select.value = chosen.id;
          updateCard(card, chosen);
        });
        shelf.querySelector('[data-xmas-empty]').hidden = visible > 0;
      };
      const initialBudget = new URLSearchParams(location.search).get('budget');
      if (['50', '100', 'premium'].includes(initialBudget)) applyBudget(initialBudget);
      section.querySelectorAll('[data-xmas-budget]').forEach(button => on(button, 'click', () => applyBudget(button.dataset.xmasBudget)));
      section.querySelectorAll('[data-xmas-budget-link]').forEach(link => on(link, 'click', () => applyBudget(link.dataset.xmasBudgetLink)));
      section.querySelectorAll('.xmas-product__form').forEach(form => on(form, 'submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-xmas-status]');
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const data = new FormData(form);
        const fallback = status.dataset.errorMessage;
        if (cart?.getSectionsToRender) {
          data.append('sections', cart.getSectionsToRender().map(item => item.section));
          data.append('sections_url', location.pathname); cart.setActiveElement?.(button);
        }
        button.disabled = true; status.textContent = ''; delete status.dataset.error;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body:data});
          const result = await response.json();
          if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || fallback);
          status.textContent = status.dataset.added;
          if (cart?.renderContents) cart.renderContents(result);
          if (typeof updateCartCounters === 'function') updateCartCounters();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'christmas-shop', productVariantId:data.get('id'), cartData:result});
          window.dataLayer?.push({event:'christmas_quick_add', christmas_section:section.id, variant_id:data.get('id')});
        } catch (error) { status.textContent = error.message || fallback; status.dataset.error = 'true'; }
        finally { button.disabled = false; }
      }));
      section.querySelectorAll('a').forEach(link => on(link, 'click', () => window.dataLayer?.push({event:'christmas_hub_click', christmas_section:section.id, link_text:link.textContent.trim(), link_url:link.getAttribute('href')})));
      if (track) {
        const toggle = section.querySelector('[data-xmas-autoplay]');
        const enabled = track.dataset.autoScroll === 'true';
        const speed = Math.max(10, Math.min(40, Number(track.dataset.scrollSpeed) || 22));
        const pauses = new Set();
        let frame = 0, previous = 0, position = 0, direction = 1, holdUntil = 0, timer = 0;
        let visible = false, manuallyPaused = false;
        const canMove = () => enabled && !reduced.matches && !manuallyPaused && visible && !document.hidden && !pauses.size;
        const tick = timestamp => {
          frame = 0;
          if (!canMove() || !section.isConnected) { previous = 0; return; }
          const elapsed = previous ? Math.min(timestamp - previous, 40) : 0;
          previous = timestamp;
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          if (maximum > 1 && timestamp >= holdUntil) {
            position = Math.max(0, Math.min(maximum, position + direction * speed * elapsed / 1000));
            track.scrollLeft = position;
            if ((direction > 0 && position >= maximum) || (direction < 0 && position <= 0)) { direction *= -1; holdUntil = timestamp + 1400; }
          }
          frame = requestAnimationFrame(tick);
        };
        const sync = () => {
          if (toggle) {
            toggle.hidden = reduced.matches || !enabled;
            toggle.setAttribute('aria-pressed', String(manuallyPaused));
            toggle.setAttribute('aria-label', manuallyPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
            toggle.querySelector('span').textContent = manuallyPaused ? '▷' : 'Ⅱ';
          }
          if (!canMove()) { cancelAnimationFrame(frame); frame = 0; previous = 0; return; }
          if (!frame) { position = track.scrollLeft; previous = 0; frame = requestAnimationFrame(tick); }
        };
        const pause = (reason, active) => { if (active) pauses.add(reason); else pauses.delete(reason); sync(); };
        const allowReading = () => {
          clearTimeout(timer); pause('interaction', true);
          timer = setTimeout(() => pause('interaction', false), 8000);
        };
        on(section, 'pointerenter', event => { if (event.pointerType !== 'touch') pause('hover', true); });
        on(section, 'pointerleave', () => pause('hover', false));
        on(track, 'pointerdown', () => { clearTimeout(timer); pause('interaction', true); });
        on(window, 'pointerup', () => { if (pauses.has('interaction')) allowReading(); });
        on(window, 'pointercancel', () => { if (pauses.has('interaction')) allowReading(); });
        on(track, 'wheel', allowReading, {passive:true});
        on(track, 'keydown', event => { if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) allowReading(); });
        on(track, 'focusin', () => pause('focus', true));
        on(track, 'focusout', () => queueMicrotask(() => pause('focus', track.contains(document.activeElement))));
        on(toggle, 'click', () => { manuallyPaused = !manuallyPaused; if (!manuallyPaused) { clearTimeout(timer); pauses.delete('interaction'); } sync(); });
        on(section.querySelector('[data-xmas-prev]'), 'click', () => { allowReading(); track.scrollBy({left:-track.clientWidth * .8, behavior:reduced.matches ? 'instant' : 'smooth'}); });
        on(section.querySelector('[data-xmas-next]'), 'click', () => { allowReading(); track.scrollBy({left:track.clientWidth * .8, behavior:reduced.matches ? 'instant' : 'smooth'}); });
        on(document, 'visibilitychange', sync);
        on(reduced, 'change', sync);
        const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:.05}) : null;
        if (observer) observer.observe(track);
        else { visible = true; sync(); }
        stopCarousel = () => { cancelAnimationFrame(frame); clearTimeout(timer); observer?.disconnect(); };
        sync();
      }
      if (!reduced.matches && !window.Shopify?.designMode && typeof IntersectionObserver === 'function') {
        const targets = section.querySelectorAll('.xmas-section-head,.xmas-occasion,.xmas-budget,.xmas-editorial__copy,.xmas-table-card,.xmas-recipe,.xmas-corporate,.xmas-delivery-grid');
        revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('xmas-reveal--waiting'); revealObserver.unobserve(entry.target);
        }), {threshold:.06, rootMargin:'0px 0px -32px 0px'});
        targets.forEach((target, index) => {
          if (target.getBoundingClientRect().top < window.innerHeight) return;
          target.classList.add('xmas-reveal', 'xmas-reveal--waiting');
          target.style.setProperty('--xmas-reveal-delay', `${Math.min(index % 4 * 45, 135)}ms`);
          revealObserver.observe(target);
        });
        on(reduced, 'change', () => {
          if (!reduced.matches) return;
          section.querySelectorAll('.xmas-reveal--waiting').forEach(target => target.classList.remove('xmas-reveal--waiting'));
          revealObserver.disconnect();
        });
      }
      controllers.set(section, () => { abort.abort(); stopCarousel(); revealObserver?.disconnect(); controllers.delete(section); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-xmas-section]').forEach(section => controllers.get(section)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('experience-video-hero')) {
    customElements.define('experience-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.videoSlot = this.querySelector('[data-video-slot]');
        this.motionButton = this.querySelector('.experience-video-hero__motion');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileViewport = window.matchMedia(`(max-width: ${this.dataset.breakpoint}px)`);
        this.saveData = navigator.connection && navigator.connection.saveData;
        this.slowConnection = navigator.connection && /(^|-)2g$/.test(navigator.connection.effectiveType || '');

        if (!this.videoSlot || this.reducedMotion.matches || this.saveData || this.slowConnection) return;

        const loadVideo = () => {
          const sourceData = this.mobileViewport.matches
            ? this.querySelector('[data-mobile-sources]')
            : this.querySelector('[data-desktop-sources]');
          if (!sourceData || this.activeVideo) return;

          try {
            this.sources = JSON.parse(sourceData.textContent);
          } catch (error) {
            return;
          }
          if (!Array.isArray(this.sources) || !this.sources.length) return;

          this.activeSegment = 0;
          this.activeVideo = this.createVideo(this.sources[0], true);
          this.bufferVideo = this.createVideo(this.sources[1] || this.sources[0], false);
          this.videoSlot.append(this.activeVideo, this.bufferVideo);
          this.motionButton.addEventListener('click', () => this.togglePlayback());
          this.activeVideo.addEventListener('playing', () => this.classList.add('is-video-ready'), { once: true });
          this.activeVideo.addEventListener('loadedmetadata', () => {
            const requestedStart = Number(this.dataset.initialStart) || 0;
            this.activeVideo.currentTime = Math.min(requestedStart, Math.max(0, this.activeVideo.duration - 0.05));
          }, { once: true });
          this.activeVideo.addEventListener('seeked', () => {
            this.motionButton.hidden = false;
            this.activeVideo.play().catch(() => {
              this.motionButton.hidden = true;
            });
          }, { once: true });
          this.activeVideo.load();
          this.bufferVideo.load();
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadVideo, { timeout: 1200 });
        } else {
          window.addEventListener('load', loadVideo, { once: true });
        }
      }

      createVideo(source, isActive) {
        const video = document.createElement('video');
        video.className = `experience-video-hero__video${isActive ? ' is-active' : ''}`;
        video.src = source;
        video.muted = true;
        video.playsInline = true;
        video.preload = isActive ? 'metadata' : 'auto';
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('ended', () => {
          if (video === this.activeVideo) this.advanceSegment();
        });
        return video;
      }

      advanceSegment() {
        const previousVideo = this.activeVideo;
        const nextVideo = this.bufferVideo;
        this.activeSegment = (this.activeSegment + 1) % this.sources.length;
        nextVideo.currentTime = 0;
        nextVideo.classList.add('is-active');
        previousVideo.classList.remove('is-active');
        this.activeVideo = nextVideo;
        this.bufferVideo = previousVideo;
        this.activeVideo.play().catch(() => {});

        const followingSegment = (this.activeSegment + 1) % this.sources.length;
        this.bufferVideo.pause();
        this.bufferVideo.src = this.sources[followingSegment];
        this.bufferVideo.preload = 'auto';
        this.bufferVideo.load();
      }

      togglePlayback() {
        if (this.activeVideo.paused) {
          this.activeVideo.play();
          this.classList.remove('is-paused');
          this.motionButton.setAttribute('aria-label', this.dataset.pauseLabel);
        } else {
          this.activeVideo.pause();
          this.classList.add('is-paused');
          this.motionButton.setAttribute('aria-label', this.dataset.playLabel);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('experience-banner-video')) {
    customElements.define('experience-banner-video', class extends HTMLElement {
      connectedCallback() {
        this.videoSlot = this.querySelector('[data-video-slot]');
        const data = this.querySelector('[data-video-sources]');
        if (!this.videoSlot || !data) return;
        try { this.sourceSets = JSON.parse(data.textContent); } catch { return; }
        this.viewport = window.matchMedia('(max-width: 749px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.onEnvironmentChange = () => this.updatePlayback();
        this.onViewportChange = () => {
          this.resetVideos();
          this.updatePlayback();
        };
        this.viewport.addEventListener('change', this.onViewportChange);
        this.motion.addEventListener('change', this.onEnvironmentChange);
        document.addEventListener('visibilitychange', this.onEnvironmentChange);
        navigator.connection?.addEventListener('change', this.onEnvironmentChange);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.updatePlayback();
        }, { threshold: 0 });
        this.visibilityObserver.observe(this);
      }

      canPlay() {
        const connection = navigator.connection;
        return this.isConnected && this.visible && !document.hidden && !this.motion.matches &&
          !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
      }

      updatePlayback() {
        if (!this.canPlay()) {
          clearTimeout(this.startTimer);
          this.startTimer = null;
          this.activeVideo?.pause();
          if (this.bufferVideo) this.releaseVideo(this.bufferVideo);
          this.bufferVideo = null;
          this.advancing = false;
          return;
        }
        if (this.activeVideo) {
          if (this.activeVideo.ended) this.advanceSegment();
          else if (this.initialSeekComplete) this.activeVideo.play().catch(() => {});
          return;
        }
        if (this.startTimer) return;
        this.startTimer = setTimeout(() => {
          this.startTimer = null;
          if (!this.canPlay() || this.activeVideo) return;
          this.sources = Array.isArray(this.sourceSets) ? this.sourceSets : this.sourceSets[this.viewport.matches ? 'mobile' : 'desktop'];
          if (!Array.isArray(this.sources) || !this.sources.length) return;
          this.activeSegment = 0;
          const video = this.createVideo(this.sources[0], 'metadata');
          this.activeVideo = video;
          video.classList.add('is-active');
          this.videoSlot.append(video);
          video.addEventListener('loadedmetadata', () => {
            const start = Math.min(Number(this.dataset.initialStart) || 0, Math.max(0, video.duration - 0.05));
            if (start > 0) {
              video.addEventListener('seeked', () => this.startInitialVideo(video), { once: true });
              video.currentTime = start;
            } else this.startInitialVideo(video);
          }, { once: true });
          video.load();
        }, 1200);
      }

      startInitialVideo(video) {
        if (video !== this.activeVideo) return;
        this.initialSeekComplete = true;
        if (this.canPlay()) video.play().catch(() => {});
      }

      createVideo(source, preload) {
        const video = document.createElement('video');
        video.className = 'hero__experience-video-player';
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = preload;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        video.src = source;
        video.addEventListener('playing', () => {
          if (video === this.activeVideo) this.classList.add('is-video-ready');
        });
        video.addEventListener('timeupdate', () => {
          if (video === this.activeVideo && !video.paused && this.canPlay() && video.duration - video.currentTime <= 4) this.prepareNext();
        });
        video.addEventListener('ended', () => {
          if (video === this.activeVideo && this.canPlay()) this.advanceSegment();
        });
        video.addEventListener('error', () => {
          if (video === this.activeVideo) this.classList.remove('is-video-ready');
        });
        return video;
      }

      prepareNext() {
        if (this.bufferVideo || !this.canPlay()) return;
        this.bufferVideo = this.createVideo(this.sources[(this.activeSegment + 1) % this.sources.length], 'auto');
        this.videoSlot.append(this.bufferVideo);
        this.bufferVideo.load();
      }

      advanceSegment() {
        if (this.advancing || !this.canPlay()) return;
        this.prepareNext();
        const next = this.bufferVideo;
        const previous = this.activeVideo;
        if (!next) return;
        this.advancing = true;
        next.addEventListener('playing', () => {
          if (next !== this.bufferVideo || !this.canPlay()) return;
          this.activeVideo = next;
          this.bufferVideo = null;
          this.activeSegment = (this.activeSegment + 1) % this.sources.length;
          next.classList.add('is-active');
          this.classList.add('is-video-ready');
          previous.classList.remove('is-active');
          this.advancing = false;
          setTimeout(() => this.releaseVideo(previous), 550);
        }, { once: true });
        next.play().catch(() => { this.advancing = false; });
      }

      releaseVideo(video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
      }

      resetVideos() {
        clearTimeout(this.startTimer);
        this.startTimer = null;
        this.videoSlot.querySelectorAll('video').forEach(video => this.releaseVideo(video));
        this.activeVideo = null;
        this.bufferVideo = null;
        this.initialSeekComplete = false;
        this.advancing = false;
        this.classList.remove('is-video-ready');
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.viewport?.removeEventListener('change', this.onViewportChange);
        this.motion?.removeEventListener('change', this.onEnvironmentChange);
        document.removeEventListener('visibilitychange', this.onEnvironmentChange);
        navigator.connection?.removeEventListener('change', this.onEnvironmentChange);
        this.resetVideos();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pukara-bookings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pukara-booking-request')) {
    class PukaraBookingRequest extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        const success = this.querySelector('[data-booking-success]');
        if (success) { success.focus(); return; }
        if (!form) return;
        const date = form.querySelector('[data-booking-date]');
        const today = new Intl.DateTimeFormat('en-CA', {timeZone:'Australia/Sydney',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const part = key => today.find(value => value.type === key).value;
        date.min = `${part('year')}-${part('month')}-${part('day')}`;
        form.addEventListener('submit', event => {
          if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
          const summary = form.querySelector('[data-booking-summary]');
          const fields = Array.from(form.querySelectorAll('[data-booking-field]')).map(field => {
            const label = field.labels?.[0]?.textContent.trim() || field.name;
            let value = field.value.trim();
            if (field === date && value) { const [year,month,day] = value.split('-'); value = `${day}/${month}/${year}`; }
            return value ? `${label}: ${value}` : '';
          }).filter(Boolean);
          summary.value = `${summary.defaultValue}\n\n${fields.join('\n')}`;
        });
      }
    }
    customElements.define('pukara-booking-request', PukaraBookingRequest);
  }

  } catch(e) { console.error(e); }
})();
})();
